import { API, graphqlOperation } from "aws-amplify";
import { currentOrdersonTransit } from "../graphql/myQueries";

const useListOrders = () => {
  let nextTokenOrders = "";
  let allOrders = [];

  const getAllOrdersbyDate = async (nextT = null) => {
    try {
      const result = await API.graphql(
        graphqlOperation(currentOrdersonTransit, {
          status: "BASKET",
          require_service: true,
          level: "FINALIZADO",
          nextToken: nextT,
        })
      );
      if (result.data.listOrders.items.length !== 0) {
        var currentResult = result.data.listOrders.items;
        currentResult.forEach((element) => {
          //myOrders.push(element);
          allOrders.push(element);
        });
      }

      nextTokenOrders = result.data.listOrders.nextToken;

      if (nextTokenOrders !== undefined && nextTokenOrders !== null) {
        await getAllOrdersbyDate(nextTokenOrders, allOrders);
      }
    } catch (error) {
      console.log("Error [listeningUpdateOrders]-->", error);
      return [];
    }
  };

  return { getAllOrdersbyDate, allOrders };
};

export default useListOrders;
